import {Page} from './Page.js';
import {Form} from './Form.js';

class PageForm extends Page
{
	constructor ()
	{
		console.log('PageForm');
		super();

		new Form( $('#frm_subscribe') );
	}
}

export {PageForm};